import React from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { BenefitsStrip } from './components/BenefitsStrip';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { TransformationSection } from './components/TransformationSection';
import { MethodSection } from './components/MethodSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { InsideCarousel } from './components/InsideCarousel';
import { TestimonialsSection } from './components/TestimonialsSection';
import { TestimonialHighlight } from './components/TestimonialHighlight';
import { PricingCards } from './components/PricingCards';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '27883251058033298';
export function App() {
  useMetaPixel();
  return <LazyMotion features={domAnimation} strict data-id="element-0" data-mp="682rygdekbl">
      <div className="min-h-full w-full bg-mp-black font-body" data-id="element-1" data-mp="82ohezguggq">
        <noscript data-id="element-2" data-mp="2zmenq84nlk7i">
          <img height={1} width={1} style={{
          display: 'none'
        }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="2zmwhmy3ufmc9" />
        </noscript>
        <main data-id="element-4" data-mp="3dkl6eh117dml">
          <Hero data-id="element-5" data-mp="3dl4l7ovdxlwe" />
          <SocialProofBar data-id="element-6" data-mp="3dlnukh6yz1yt" />
          <BenefitsStrip data-id="element-7" data-mp="3diruam7ng177" />
          <TransformationSection data-id="element-8" data-mp="nvsvva68mxyl" />
          <MethodSection data-id="element-9" data-mp="nuhicimzqbua" />
          <ForWhoSection data-id="element-10" data-mp="nvas7sh8xhgn" />
          <TomosSection data-id="element-11" data-mp="sund47ok4egl" />
          <BonosSection data-id="element-12" data-mp="su427axbqqc2" />
          <InsideCarousel data-id="element-13" data-mp="stc6m03q8sls" />
          <TestimonialsSection data-id="element-14" data-mp="swqajcs1h9vc" />
          <TestimonialHighlight data-id="element-15" data-mp="3688rpx40wyp" />
          <PricingCards data-id="element-16" data-mp="356rv4texg92" />
          <GuaranteeSection data-id="element-17" data-mp="38kwkjpju1jo" />
          <FAQSection data-id="element-18" data-mp="3ud1glcmeruc7" />
          <FinalCTA data-id="element-19" data-mp="3udkmtw2p4uae" />
        </main>
        <Footer data-id="element-20" data-mp="3ucjdpx58qhvb" />
        <StickyMobileCTA data-id="element-21" data-mp="3uf5hrmsxaf8s" />
        <PurchaseNotifications data-id="element-22" data-mp="d57g95652mk4" />
      </div>
    </LazyMotion>;
}